import getApiInstance from '@/services/Api.ts'
import { AxiosResponse } from 'axios'

const api = getApiInstance()

export interface FeedbackSubmission {
  rating: number // 1-5
  support_session: boolean // true if they want a support session, false if not
  subject: string // one of: compliment, feature_request, feedback, bug_report, other
  feedback: string // min 10, max 5000 characters
}

export interface FeedbackResponse {
  message: string
  data: {
    id: number
    rating: number
    subject: string
    subject_label: string
    feedback: string
    attachments_count: number
    created_at: string
    user: {
      id: string
      name: string
    }
  }
}

export interface ValidationError {
  message: string
  errors: Record<string, string[]>
}

export default {
  submitFeedback(payload: FeedbackSubmission): Promise<AxiosResponse<FeedbackResponse>> {
    return api.Post('/customer-feedback', payload)
  },
}